// import { useOpenAiGlobal } from "../use-openai-global";
import { createRoot } from "react-dom/client";
import App from "./App";

const root = document.getElementById("parser-resume-mcp-root");

if (root) {
  createRoot(root).render(<App />);
}

export default App;
